module.exports = __webpack_public_path__ + "static/img/iron-ingot_256.e07ca42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iron-ingot_256.png
// module id = nviP
// module chunks = 0